import React, { useState } from 'react';
import SubscriptionList from '../SubscriptionList/SubscriptionList';
import EditSubscriptions from '../EditSubscriptions/EditSubscriptions';
import SubscriptionSlideOutModal from '../SlideUpModal/SubscriptionSlideOutModal/SubscriptionSlideOutModal';

const SubscriptionsTile = (props) => {
  const [modalOpen, setModalOpen] = useState(false);

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  return (
    <div>
      <div>
        <SubscriptionList modalOpen={modalOpen} toggleModal={toggleModal} />
      </div>
      <SubscriptionSlideOutModal
        isOpen={modalOpen}
        toggleModal={toggleModal}
      >
        <EditSubscriptions toggleModal={toggleModal} />
      </SubscriptionSlideOutModal>
    </div>
  );
};

export default SubscriptionsTile;
